export default [
  {
    name: 'Bpr Consultar',
    path: '/bpr',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Bpr',
        path: 'consultar',
        component: () => import('@/views/bpr/Consultar.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'BPR' }]
        }
      }
    ]
  }
];
